import css from '../tpl-css/style-section-slider-review-kynorelle.js';
const html = `
<style>${css}</style>
<div
  data-attribute="card-container"
  id="card-container-unique-id"
  data-id="unique-id"
  data-background="#FFFFFF"
  data-top-padding="true"
  data-bottom-padding="true"
  data-color="#000000"
  style="background-color: #ffffff; color: #000000; --text-color: #000000;"
>
  <div
    class="container-page"
    data-attribute="container-page"
    data-show-style="false"
    data-background="#FFFFFF"
    style="background-color: transparent;"
  >
    <div class="container">
      <div data-show="true" data-attribute="title-card" class="title-card">
        <h2 style="text-align:center;">
          <span style="color:#003566;"><strong>57,481+</strong></span>
        </h2>
        <p style="text-align:center;"><span style="color:#003566;">Happy customers</span></p>
      </div>
      <div class="wrap-card">
        <div>
          <div data-attribute="body-review" class="body-review swiper" data-col-per-view="3">
            <div class="review-slider swiper-wrapper">
              <div data-attribute="item-review" class="item-review swiper-slide">
                <div class="content-item">
                  <div class="review-image-container">
                    <img
                      loading="lazy"
                      data-attribute="review-image"
                      src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e64dd817dbf1ff93d821.png"
                      alt="review image"
                      class="review-image"
                    />
                  </div>
                  <div class="review-content">
                    <div>
                      <div data-attribute="wrap-stars" class="wrap-stars" data-value="5">
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                      </div>
                      <div class="review-content-text" data-attribute="review-content">
                        <p>
                          <span style="color:#6d6f74;"
                            >“I can't recommend these pants enough! As a lady with curvy thighs and booty, I've had a
                            hard time finding pull-on pants that are flattering on me and don't look frumpy. These are
                            it! The fabric is soft, smooth and no wrinkles after washing. Buy 2 and definitely buy more
                            for my friends!”</span
                          >
                        </p>
                      </div>
                    </div>
                    <div>
                      <div class="review-name" data-attribute="review-name">Stella D.</div>
                      <div class="verified-buyer">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                            fill="#42ADA4"
                          />
                          <path
                            d="M11.8173 4.56738L6.88729 9.49738L4.85728 7.46738L3.84229 8.48238L6.88729 11.5274L12.8323 5.58238L11.8173 4.56738Z"
                            fill="#E3F2FD"
                          />
                        </svg>
                        <span>verified buyer</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-attribute="item-review" class="item-review swiper-slide">
                <div class="content-item">
                  <div class="review-image-container">
                    <img
                      loading="lazy"
                      data-attribute="review-image"
                      src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e697f68b7b4921c9d246.png"
                      alt="review image"
                      class="review-image"
                    />
                  </div>
                  <div class="review-content">
                    <div>
                      <div data-attribute="wrap-stars" class="wrap-stars" data-value="5">
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                      </div>
                      <div class="review-content-text" data-attribute="review-content">
                        <p>
                          <span style="color:#6d6f74;"
                            >“I just love these. The material is so soft. And there is stretch to it as well. I can’t
                            say enough about them and they don’t wrinkle .Great product. Highly recommend. I bought for
                            my daughter too”</span
                          >
                        </p>
                      </div>
                    </div>
                    <div>
                      <div class="review-name" data-attribute="review-name">Alexa H.</div>
                      <div class="verified-buyer">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                            fill="#42ADA4"
                          />
                          <path
                            d="M11.8173 4.56738L6.88729 9.49738L4.85728 7.46738L3.84229 8.48238L6.88729 11.5274L12.8323 5.58238L11.8173 4.56738Z"
                            fill="#E3F2FD"
                          />
                        </svg>
                        <span>verified buyer</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div data-attribute="item-review" class="item-review swiper-slide">
                <div class="content-item">
                  <div class="review-image-container">
                    <img
                      loading="lazy"
                      data-attribute="review-image"
                      src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0e6b3ab3da80f3268eadf.png"
                      alt="review image"
                      class="review-image"
                    />
                  </div>
                  <div class="review-content">
                    <div>
                      <div data-attribute="wrap-stars" class="wrap-stars" data-value="5">
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                        <svg width="19" height="17" viewBox="0 0 19 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M9.21375 0L6.71836 5.94141L0 6.37559L5.15874 10.4889L3.52714 16.6816L9.21375 13.2768L14.9004 16.6816L13.2688 10.4889L18.4275 6.37559L11.7091 5.94141L9.21375 0Z"
                            fill="#F9AC07"
                          />
                        </svg>
                      </div>
                      <div class="review-content-text" data-attribute="review-content">
                        <p>
                          <span style="color:#6d6f74;"
                            >“I love these pants because they are so silky smooth against my skin and I bench really
                            easily thanks to the super stretchy fabric. I highly recommend these. Just wish they have
                            more colors”</span
                          >
                        </p>
                      </div>
                    </div>
                    <div>
                      <div class="review-name" data-attribute="review-name">Zephyra X.</div>
                      <div class="verified-buyer">
                        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                          <path
                            d="M7.975 0L9.60625 1.8125L11.9625 1.0875L12.5063 3.44375L14.8625 3.9875L14.1375 6.34375L15.95 7.975L14.1375 9.60625L14.8625 11.9625L12.5063 12.5063L11.9625 14.8625L9.60625 14.1375L7.975 15.95L6.34375 14.1375L3.9875 14.8625L3.44375 12.5063L1.0875 11.9625L1.8125 9.60625L0 7.975L1.8125 6.34375L1.0875 3.9875L3.44375 3.44375L3.9875 1.0875L6.34375 1.8125L7.975 0Z"
                            fill="#42ADA4"
                          />
                          <path
                            d="M11.8173 4.56738L6.88729 9.49738L4.85728 7.46738L3.84229 8.48238L6.88729 11.5274L12.8323 5.58238L11.8173 4.56738Z"
                            fill="#E3F2FD"
                          />
                        </svg>
                        <span>verified buyer</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="swiper-button-next"></div>
        <div class="swiper-button-prev"></div>

        <div class="swiper-pagination"></div>
      </div>
      <div data-show-button="true" data-attribute="button" class="button" style="display: block;">
        <a
          data-attribute="card-btn"
          class="card-btn"
          href="#"
          data-radius="4"
          data-background="#003568"
          data-color="#ffffff"
          style="--color-btn: #ffffff; --background-btn: #003568; --border-radius-btn: 4px; border-radius: 4px;"
        >
          <span data-attribute="btn-text">TRY IT TODAY, RISK-FREE !</span>
          <div class="icon-btn">
            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M0 0L3.51 4.78636L0 9.57273H2.34L5.85 4.78636L2.34 0H0Z" fill="currentColor"></path>
            </svg>
          </div>
        </a>
      </div>
    </div>
  </div>
</div>
`;
export default html;
